import styles from './W_PaymentScenarioPurchaseContent.module.css';
import W_PaymentCard from '../W_PaymentCard/W_PaymentCard';
import W_PaymentScenarioPurchase from '../W_PaymentScenarioPurchase/W_PaymentScenarioPurchase';

export default function W_PaymentScenarioPurchaseContent() {
  return (
    <div className={styles.wrapper}>
      <W_PaymentCard />
      <W_PaymentScenarioPurchase />
    </div>
  );
}
